import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  EXPORT ORDERS SERVICE
export const exportOrdersService = createAsyncThunk(
  "reports/exportOrdersService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.exportOrdersURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);
